/* eslint no-param-reassign: "off" */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Teacher from '../../types/Teacher';

interface State {
  ids: number[];
  values: Record<number, Teacher>;
}

const initialState: State = {
  ids: [],
  values: {},
};

const teachersSlice = createSlice({
  name: 'teachers',
  initialState,
  reducers: {
    addTeacher: (state, action: PayloadAction<Teacher>) => {
      const { id } = action.payload;
      state.ids.push(id);
      state.values[id] = action.payload;
    },

    updateTeacher: (state, action: PayloadAction<Teacher>) => {
      const { id } = action.payload;
      state.values[id] = action.payload;
    },

    deleteTeacher: (state, action: PayloadAction<number>) => {
      const id = action.payload;
      state.ids.splice(state.ids.indexOf(id), 1);
      delete state.values[id];
    },

    setAllTeachers: (state, action: PayloadAction<Teacher[]>) => {
      state.ids = [];
      state.values = {};

      action.payload.forEach((value) => {
        const { id } = value;
        state.ids.push(id);
        state.values[id] = value;
      });
    },
  },
});

export const selectTeachers = (state: any): Record<number, Teacher> =>
  state.teachers.values;

export const { setAllTeachers, addTeacher, updateTeacher, deleteTeacher } =
  teachersSlice.actions;
export default teachersSlice.reducer;
